import React from 'react';
import { MFOutlet, XvAppId } from '@im/ui-lib/mf-utils';
import { ProviderComposer } from './AppProviderComposer';
import { getAppProviders } from './app-provider-config';
import { LicenseInfo } from '@mui/x-license-pro';
import { SameOriginApiSwitch } from '../query/SameOriginApiSwitch';

type AppProvidersProps = {
  appId: XvAppId;
  basename?: string;
  children: React.ReactNode;
  envVars: any;
  mfOutlets?: MFOutlet[];
};

LicenseInfo.setLicenseKey(process.env.INGRAM__MUI_PRO_KEY ?? '');

export function AppProvidersV2({
  appId,
  children,
  ...others
}: AppProvidersProps) {
  const appProviders = getAppProviders(appId, others);

  return (
    <ProviderComposer providers={appProviders}>
      {appId === 'cep' && <SameOriginApiSwitch />}
      {children}
    </ProviderComposer>
  );
}
